import { TOP_BLOCK } from "../../Data/typeDirs"
import { genId } from "../../utils"



export class TopBlock{

  constructor(data = {}){
    this._id = data._id || genId()
    this._reports_v2 = data._reports_v2
    this.created = data.created || Date.now()
    this._createdBy = data._createdBy || null
    this._modifiedBy = data._modifiedBy || data._createdBy
    this.type = TopBlock.getTypeDir()
    this.schema = data.schema || 'topBlockSchema'
    this.name = data.name || null
    this.coverPhoto = data.coverPhoto || null
    this.preparedFor = data.preparedFor || null
    this.preparedBy = data.preparedBy || null
    this.preparedForPhoto = data.preparedForPhoto || null
    this.preparedForAddress = data.preparedForAddress || null
    this.preparedByPhoto = data.preparedByPhoto || null
    this.preparedByAddress = data.preparedByAddress || null
    this.propertyAddress = data.propertyAddress || null
    this.reportType = data.reportType || null
    this.date = data.date || null
    this.projectManagerStatement = data.projectManagerStatement || null
    this.signatorsTitle = data.signatorsTitle || null
    this.signatorsName = data.signatorsName || null
    this.signature = data.signature || null
    this.executiveSummary = data.executiveSummary || null
  }

  static createDefaultTopBlock(reportId){
    return new TopBlock({
      _reports_v2:reportId,
    })
  }
  



  static getTypeDir() { return TOP_BLOCK }
  static getIndices() { return '_id,_reports_v2' }


}